// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/experiment_summary_csv_row.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ChannelIds } from "../../../common/types/v1/channel_ids_pb";
import { file_quanterix_common_types_v1_channel_ids } from "../../../common/types/v1/channel_ids_pb";
import type { CurveType } from "../../../common/types/v1/curve_type_pb";
import { file_quanterix_common_types_v1_curve_type } from "../../../common/types/v1/curve_type_pb";
import type { CurveWeightType } from "../../../common/types/v1/curve_weight_type_pb";
import { file_quanterix_common_types_v1_curve_weight_type } from "../../../common/types/v1/curve_weight_type_pb";
import type { SampleType } from "../../../common/types/v1/sample_type_pb";
import { file_quanterix_common_types_v1_sample_type } from "../../../common/types/v1/sample_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/experiment_summary_csv_row.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_experiment_summary_csv_row: GenFile = /*@__PURE__*/
  fileDesc("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", [file_quanterix_common_types_v1_channel_ids, file_quanterix_common_types_v1_curve_type, file_quanterix_common_types_v1_curve_weight_type, file_quanterix_common_types_v1_sample_type]);

/**
 * Represents a single row in the Experiment Summary CSV export file
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.ExperimentSummaryCsvRow
 */
export type ExperimentSummaryCsvRow = Message<"quanterix.simoa_one.analysis_app_api.v1.ExperimentSummaryCsvRow"> & {
  /**
   * @generated from field: optional string sample_name = 1;
   */
  sampleName?: string;

  /**
   * @generated from field: optional quanterix.common.types.v1.SampleType sample_type = 2;
   */
  sampleType?: SampleType;

  /**
   * @generated from field: optional string assay_protocol = 3;
   */
  assayProtocol?: string;

  /**
   * @generated from field: optional string well_position = 4;
   */
  wellPosition?: string;

  /**
   * @generated from field: optional string analyte = 5;
   */
  analyte?: string;

  /**
   * @generated from field: optional string bead_id = 6;
   */
  beadId?: string;

  /**
   * @generated from field: optional double aeb = 7;
   */
  aeb?: number;

  /**
   * @generated from field: optional double mean_aeb = 8;
   */
  meanAeb?: number;

  /**
   * @generated from field: optional double aeb_cv = 9;
   */
  aebCv?: number;

  /**
   * @generated from field: optional double aeb_sd = 10;
   */
  aebSd?: number;

  /**
   * @generated from field: optional double concentration = 11;
   */
  concentration?: number;

  /**
   * @generated from field: optional string unit = 12;
   */
  unit?: string;

  /**
   * @generated from field: optional double dilution = 13;
   */
  dilution?: number;

  /**
   * @generated from field: optional double final_concentration = 14;
   */
  finalConcentration?: number;

  /**
   * @generated from field: optional double mean_concentration = 15;
   */
  meanConcentration?: number;

  /**
   * @generated from field: optional double expected_concentration = 16;
   */
  expectedConcentration?: number;

  /**
   * @generated from field: optional double stddev = 17;
   */
  stddev?: number;

  /**
   * @generated from field: optional double concentration_cv = 18;
   */
  concentrationCv?: number;

  /**
   * @generated from field: optional double percent_bias = 19;
   */
  percentBias?: number;

  /**
   * @generated from field: optional double percent_recovery = 20;
   */
  percentRecovery?: number;

  /**
   * @generated from field: optional double min_concentration = 21;
   */
  minConcentration?: number;

  /**
   * @generated from field: optional double max_concentration = 22;
   */
  maxConcentration?: number;

  /**
   * @generated from field: optional double lod = 23;
   */
  lod?: number;

  /**
   * @generated from field: optional double lloq = 24;
   */
  lloq?: number;

  /**
   * @generated from field: optional double uloq = 25;
   */
  uloq?: number;

  /**
   * @generated from field: optional quanterix.common.types.v1.CurveType fit_model = 26;
   */
  fitModel?: CurveType;

  /**
   * @generated from field: optional quanterix.common.types.v1.CurveWeightType curve_weighting = 27;
   */
  curveWeighting?: CurveWeightType;

  /**
   * @generated from field: optional quanterix.common.types.v1.CurveType equation = 28;
   */
  equation?: CurveType;

  /**
   * @generated from field: optional double a_value = 29;
   */
  aValue?: number;

  /**
   * @generated from field: optional double b_value = 30;
   */
  bValue?: number;

  /**
   * @generated from field: optional double c_value = 31;
   */
  cValue?: number;

  /**
   * @generated from field: optional double d_value = 32;
   */
  dValue?: number;

  /**
   * @generated from field: optional double e_value = 49;
   */
  eValue?: number;

  /**
   * @generated from field: optional double regression_coefficient = 33;
   */
  regressionCoefficient?: number;

  /**
   * @generated from field: optional string curve_fit_module_version = 34;
   */
  curveFitModuleVersion?: string;

  /**
   * @generated from field: optional string software_version = 35;
   */
  softwareVersion?: string;

  /**
   * @generated from field: optional string analysis_date = 36;
   */
  analysisDate?: string;

  /**
   * @generated from field: optional string report_date = 37;
   */
  reportDate?: string;

  /**
   * @generated from field: optional double fon = 38;
   */
  fon?: number;

  /**
   * @generated from field: optional double isingle = 39;
   */
  isingle?: number;

  /**
   * @generated from field: optional double ibead = 40;
   */
  ibead?: number;

  /**
   * @generated from field: optional double bead_number = 41;
   */
  beadNumber?: number;

  /**
   * @generated from field: optional double bead_on = 42;
   */
  beadOn?: number;

  /**
   * @generated from field: optional double bead_off = 43;
   */
  beadOff?: number;

  /**
   * @generated from field: optional string bead_region = 44;
   */
  beadRegion?: string;

  /**
   * @generated from field: optional string probe_region = 45;
   */
  probeRegion?: string;

  /**
   * @generated from field: optional quanterix.common.types.v1.ChannelIds reporter_channel = 46;
   */
  reporterChannel?: ChannelIds;

  /**
   * @generated from field: optional double ion = 47;
   */
  ion?: number;

  /**
   * @generated from field: optional double ioff = 48;
   */
  ioff?: number;

  /**
   * @generated from field: optional bool excluded = 50;
   */
  excluded?: boolean;

  /**
   * @generated from field: optional string experiment_name = 51;
   */
  experimentName?: string;

  /**
   * @generated from field: optional string analysis_engine_version = 52;
   */
  analysisEngineVersion?: string;

  /**
   * @generated from field: optional double recovery_cutoff_calibrator = 53;
   */
  recoveryCutoffCalibrator?: number;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.ExperimentSummaryCsvRow.
 * Use `create(ExperimentSummaryCsvRowSchema)` to create a new message.
 */
export const ExperimentSummaryCsvRowSchema: GenMessage<ExperimentSummaryCsvRow> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_experiment_summary_csv_row, 0);

